import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

import _ from 'lodash';

const MorePage: React.FC = () => {
  const { user, logout } = useAuth();

  const menuItems = [
    { path: '/profile', label: '프로필' },
    { path: '/setting', label: '설정' },
    { path: '/setting/qna-list', label: '문의사항' },
    { path: '/counseling/list', label: '리본상담 내역' },
  ];

  if(_.get(user,"role") === 'admin'){
    menuItems.push({path:'/admin',label:'관리자페이지'})
  }

  return (
    <div className="more-page app-container">
      <ul className="menu-list">
        {menuItems.map(item => (
          <li key={_.get(item,"path")} className="menu-item">
            <Link to={_.get(item,"path")} className="menu-link">
              {_.get(item,"label")}
            </Link>
          </li>
        ))}
        <li className="menu-item">
          <button onClick={logout} className="menu-link logout-button">
            로그아웃
          </button>
        </li>
      </ul>
    </div>
  );
};

export default MorePage;
